module.exports = {
      id: "ic-pointfigure-normal-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-pointfigure-normal-usage",
      toString: function () {
        return this.url;
      }
    }